<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="600px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="100px" :rules="rules">
          <el-form-item label="库区编号" prop="Code">
            <el-input
              v-model="form.Code"
              placeholder="请输入库区编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="库区名称" prop="Name">
            <el-input
              v-model="form.Name"
              placeholder="请输入库区名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="货区类型">
            <SelectDicValue
              ref="SelectDicValue"
              code="StorAreaType"
              v-model="form.Type"
            ></SelectDicValue>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import SelectDicValue from '@/components/DicValue/SelectDicValue.vue'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      form: {
        Code: '',
        Name: '',
        Type: '',
      },
      rules: {
        Code: [{ required: true, message: '请输入用户编号', trigger: 'blur' }],
        Name: [
          { required: true, message: '请输入用户名账号', trigger: 'blur' },
        ],
      },
      drawer: false,
    }
  },
  props: {},
  components: { SelectDicValue },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    handleSubmit() {
      console.log(this.form)
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/PB/PB_StorArea/SaveData', {
            ...this.form,
            StorId: '1111',
          })
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.form = { Code: '', Name: '', Type: '' }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/PB/PB_StorArea/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
